import { css, StyleSheet } from 'aphrodite'
import React from 'react'

import { BaseEntityPageSlixta } from '../../../components/BaseEntityPageSlixta'
import { AppConfig } from '../../../AppConfig'
import { AppTheme } from '../../../styles/AppTheme'
import { ApiHelper } from '../../../common/helpers/ApiHelper'
import { Helper } from '../../../common/helpers/Helper'
import { AppUiHelper } from '../../../helpers/AppUiHelper'
import { AppHelper } from '../../../helpers/AppHelper'
import { ChatbotFlowCanvas } from './whatsapp-chatbot/ChatbotFlowCanvas'
import { ChatbotNodePalette } from './whatsapp-chatbot/ChatbotNodePalette'
import { ChatbotEmptyStart } from './whatsapp-chatbot/ChatbotEmptyStart'
import {
  NODE_TYPE_AGENT,
  NODE_TYPE_CONTACT,
  NODE_TYPE_MESSAGE,
  NODE_TYPE_START_CHATBOT,
  NODE_TYPE_TEMPLATE,
  addConnectedNode,
  addEdge,
  addNode,
  botJsonFromChatbot,
  chatbotFromRecord,
  duplicateNode,
  getNodeById,
  getNodePalette,
  isChatbotUnpublished,
  persistTemplateNodeData,
  removeEdge,
  removeNode,
  setStartNode,
  toggleNodeDefault,
  updateNodeData,
  updateNodePosition,
} from './whatsapp-chatbot/chatbotGraph'
import {
  formDataToNodeData,
  getChatbotMessageFieldDef,
  nodeDataToFormItem,
  patchMessageContactVariables,
  patchMessageFlowOptions,
  uploadLinksFromForm,
} from './whatsapp-chatbot/chatbotMessageForm'
import {
  buildContactStateOptions,
  buildContactTagOptions,
  contactNodeDataToFormItem,
  formDataToContactNodeData,
  getChatbotContactFieldDef,
  patchContactFormOptions,
} from './whatsapp-chatbot/chatbotContactForm'
import { LOADING_FLOW_OPTIONS, fetchWhatsappFlowOptionsForNumber } from './whatsapp-chatbot/chatbotFlows'
import {
  crmNumbersFromResult,
  getDefaultWabaNumber,
} from './whatsapp-chatbot/chatbotTemplates'
import { ChatbotConfirmDialog } from './whatsapp-chatbot/ChatbotConfirmDialog'
import {
  LOADING_LIVE_CHATBOT_OPTIONS,
  chatbotLabelMap,
  fetchLiveChatbots,
  liveChatbotSelectOptions,
} from './whatsapp-chatbot/chatbotStartChatbots'
import {
  formDataToStartChatbotNodeData,
  getChatbotStartChatbotFieldDef,
  patchStartChatbotSelectOptions,
  startChatbotNodeDataToFormItem,
} from './whatsapp-chatbot/chatbotStartChatbotForm'
import {
  agentNodeDataToFormItem,
  agentProviderOptions,
  formDataToAgentNodeData,
  getChatbotAgentFieldDef,
} from './whatsapp-chatbot/chatbotAgentForm'
import {
  brokenPreviewForKeys,
  firstTemplateIssue,
  indexWaTemplatePreviews,
  invalidStepsReason,
  mappedTemplateKeys,
} from './whatsapp-chatbot/chatbotTemplatePreview'
import { WaTemplateKeyDialog } from './WaTemplateKeyDialog'

export class WhatsappChatbotDetail extends BaseEntityPageSlixta {
  constructor(props) {
    super(props)
    this.ms = AppConfig.CDP_MS.ENDPOINT
    this.pageTitle = 'WhatsApp chatbot'
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.chatbotId = this.props.match.params.id
    this.attribsGroupId = 'settingscrmcontactattrs' + this.orgId
    this.breadCrumbs = [
      { title: 'WhatsApp chatbots', to: `${this.baseRoute()}/whatsapp-chatbots`, type: 'button', icon: 'arrow_back_ios' },
    ]
    this.toFetch = [
      {
        key: 'chatbot',
        ms: this.ms,
        method: 'GET',
        paths: ['wacontents', this.chatbotId],
        queryParams: { orgId: this.orgId },
      },
    ]
    this.flowOptions = []
    this.flowsReady = false
    this.flowLoadPromise = null
    this.stateOptions = []
    this.tagOptions = []
    this.crmContactsFieldDef = null
    this.crmContactAttrs = null
    this.crmNumbers = []
    this.defaultWabaNumber = ''
    this.waContextReady = false
    this.waContextPromise = null
    this.crmContactsReady = false
    this.crmContactsPromise = null
    this.crmAttrsReady = false
    this.crmAttrsPromise = null
    this.templateVariables = AppUiHelper.getContactTemplateVariables()
    this.liveChatbotOptions = []
    this.chatbotLabelMap = {}
    this.liveChatbotsReady = false
    this.liveChatbotLoadPromise = null
    this.agentSettingsCache = null
    this.templatePreviewByKey = {}
    this.templatePreviewLoadId = 0
    this.templatePreviewPromise = null
    this.apiData = { orgId: this.orgId }
    this.pageKey = this.pageTitle
    this.noAdd = true
    const imageField = Helper.getField(getChatbotMessageFieldDef(), 'image')
    this.enableAssetPicker({
      allowedFormats: imageField ? Helper.getAllowedFormatsFromImageField(imageField) : undefined,
    })
    this.flowCanvasRef = React.createRef()
    this.dirty = false
    this.saving = false
    this.allowLeave = false
    this.state = {
      ...this.state,
      templateWaDialogOpen: false,
      templateWaValue: null,
    }
  }

  componentDidMount() {
    super.componentDidMount()
    this.unblock = this.props.history.block((location, action) => {
      if (!this.dirty || this.allowLeave) return true
      this.pendingLocation = location
      this.pendingAction = action
      this.pendingRefreshCallback = null
      this.setState({ leaveConfirmOpen: true })
      return false
    })
    window.addEventListener('beforeunload', this.onBeforeUnload)
  }

  componentWillUnmount() {
    if (this.unblock) this.unblock()
    window.removeEventListener('beforeunload', this.onBeforeUnload)
  }

  onBeforeUnload = (e) => {
    if (!this.dirty) return
    e.preventDefault()
    e.returnValue = ''
  }

  async onFetchSuccess(results) {
    const record = this.getResult(results, 'chatbot')
    if (!record || String(record.iType || '').toUpperCase() !== 'CHATBOT') {
      this.setState({
        fetchState: ApiHelper.State.ERROR,
        loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD,
        errMsg: 'This is not a WhatsApp chatbot.',
      })
      throw new Error('not a chatbot')
    }
    this.chatbotId = record.id || this.chatbotId
    this.chatbot = chatbotFromRecord(record)
    this.dirty = false
    this.pageTitle = this.chatbot.name || 'WhatsApp chatbot'
    this.pageKey = this.pageTitle
    this.setHeaderActions()
    this.setState({ items: [] })
    await this.ensureTemplatePreviews()
    this.setHeaderActions()
    this.prefetchForExistingTypes()
  }

  fetchItems(onReadyCallback) {
    if (this.dirty) {
      this.pendingLocation = null
      this.pendingAction = 'REFRESH'
      this.pendingRefreshCallback = onReadyCallback
      this.setState({ leaveConfirmOpen: true })
      return
    }
    super.fetchItems(onReadyCallback)
  }

  setHeaderActions() {
    this.headerActions = []
    const hasNodes = !!((this.chatbot && this.chatbot.nodes) || []).length
    const unpublished = isChatbotUnpublished(this.chatbot && this.chatbot.state)
    const blockReason = this.templateBlockReason()
    if (hasNodes && unpublished) {
      this.headerActions.push({
        label: 'Start',
        tooltip: blockReason || 'Start',
        icon: 'send',
        type: 'icon-label',
        disabled: !!blockReason,
        onClick: () => this.startChatbot(),
      })
    }
    if (!unpublished) {
      this.headerActions.push({
        label: 'Pause',
        tooltip: 'Pause',
        icon: 'pause',
        type: 'icon-label',
        onClick: () => this.pauseChatbot(),
      })
    }
    this.headerActions.push({
      label: 'Refresh',
      tooltip: 'Refresh',
      icon: 'refresh',
      type: 'icon-label',
      onClick: () => this.fetchItems(),
    })
  }

  persistChatbot(nextState, successMsg) {
    if (!this.chatbot || !this.chatbot.id || this.saving) return Promise.resolve()
    const state = nextState || this.chatbot.state || 'DISABLED'
    this.saving = true
    this.setHeaderActions()
    this.setState({})
    const botJson = botJsonFromChatbot(this.chatbot)
    return ApiHelper.callAwait({
      ms: this.ms,
      method: 'PUT',
      paths: ['wacontents', this.chatbot.id],
      queryParams: { orgId: this.orgId },
      jsonBody: {
        orgId: this.orgId,
        title: this.chatbot.name,
        botJson,
        state,
      },
    }).then(() => {
      this.chatbot = { ...this.chatbot, state }
      this.dirty = false
      this.saving = false
      this.setHeaderActions()
      this.setState({
        showToast: true,
        isErrorToast: false,
        toastMsg: successMsg,
      })
    }).catch(err => {
      this.saving = false
      this.setHeaderActions()
      this.setState({
        showToast: true,
        isErrorToast: true,
        toastMsg: Helper.getErrorMsg(err),
      })
    })
  }

  templateBlockReason() {
    return firstTemplateIssue(this.chatbot, this.templatePreviewByKey)
      ? invalidStepsReason()
      : ''
  }

  startChatbot() {
    if (!this.chatbot || !isChatbotUnpublished(this.chatbot.state)) return
    if (!((this.chatbot.nodes || []).length)) return
    if (this.templateBlockReason()) return
    this.persistChatbot('LIVE', 'Chatbot started')
  }

  pauseChatbot() {
    if (!this.chatbot || isChatbotUnpublished(this.chatbot.state)) return
    this.persistChatbot('DISABLED', 'Chatbot paused')
  }

  saveChatbot() {
    if (!this.dirty || this.saving) return
    if (this.templateBlockReason()) return
    this.persistChatbot(this.chatbot.state || 'DISABLED', 'Chatbot saved')
  }

  setChatbot(next) {
    this.chatbot = next
    this.dirty = true
    this.setHeaderActions()
    this.setState({})
  }

  /** Trigger Agent node + provider list from tenant CDP settings (cached until the settings change). */
  agentSettings() {
    const enabled = AppHelper.isSettingEnabled(this.orgId, 'WHATSAPP_CHATBOT_AGENT')
    const configStr = AppHelper.getSetting(this.orgId, 'WHATSAPP_CHATBOT_AGENT_CONFIG') || ''
    const cache = this.agentSettingsCache
    if (cache && cache.enabled === enabled && cache.configStr === configStr) return cache
    this.agentSettingsCache = {
      enabled,
      configStr,
      palette: getNodePalette({ agentEnabled: enabled }),
      providerOptions: agentProviderOptions(configStr),
    }
    return this.agentSettingsCache
  }

  addChatbotNode = (type) => {
    const nodes = (this.chatbot && this.chatbot.nodes) || []
    if (!nodes.length) {
      const canStart = (this.agentSettings().palette || []).some(item => item && item.start && item.type === type)
      if (!canStart) return
    }
    const api = this.flowCanvasRef.current
    const position = api && api.getAddPosition ? api.getAddPosition() : null
    this.setChatbot(addNode(this.chatbot, type, position || undefined))
    this.prefetchForType(type)
  }

  onNodeDragStop = (nodeId, posX, posY) => {
    const node = getNodeById(this.chatbot, nodeId)
    if (!node) return
    const prevX = node.position && node.position.posX
    const prevY = node.position && node.position.posY
    if (prevX === posX && prevY === posY) return
    this.setChatbot(updateNodePosition(this.chatbot, nodeId, posX, posY))
  }

  onConnectNodes = (sourceNodeId, targetNodeId, sourceHandle) => {
    this.setChatbot(addEdge(this.chatbot, sourceNodeId, targetNodeId, sourceHandle))
  }

  addConnectedChatbotNode = (sourceNodeId, sourceHandle, type, position) => {
    this.setChatbot(addConnectedNode(this.chatbot, sourceNodeId, sourceHandle, type, position))
    this.prefetchForType(type)
  }

  onEdgeDelete = (edgeId) => {
    this.setChatbot(removeEdge(this.chatbot, edgeId))
  }

  onNodeDelete = (nodeId) => {
    this.setChatbot(removeNode(this.chatbot, nodeId))
  }

  onNodeDuplicate = (nodeId) => {
    this.setChatbot(duplicateNode(this.chatbot, nodeId))
  }

  onSetStartNode = (nodeId) => {
    this.setChatbot(setStartNode(this.chatbot, nodeId))
  }

  onNodeToggleDefault = (nodeId) => {
    this.setChatbot(toggleNodeDefault(this.chatbot, nodeId))
  }

  onAutoLayout = (next) => {
    this.setChatbot(next)
  }

  prefetchForExistingTypes() {
    const seen = {}
    const nodes = (this.chatbot && this.chatbot.nodes) || []
    for (let i = 0; i < nodes.length; i++) {
      const type = nodes[i] && nodes[i].type
      if (!type || seen[type]) continue
      seen[type] = true
      this.prefetchForType(type)
    }
  }

  prefetchForType(type) {
    if (type === NODE_TYPE_MESSAGE) {
      this.ensureFlowOptions()
      this.ensureCrmContacts()
      return
    }
    if (type === NODE_TYPE_CONTACT) {
      this.ensureCrmContacts()
      this.ensureCrmAttrs()
      return
    }
    if (type === NODE_TYPE_START_CHATBOT) {
      this.ensureLiveChatbots()
    }
  }

  ensureWaContext() {
    if (this.waContextPromise) return this.waContextPromise
    if (this.waContextReady) return Promise.resolve()
    this.waContextPromise = ApiHelper.callAwait({
      ms: this.ms,
      method: 'GET',
      paths: ['crmnumbers'],
      queryParams: { orgId: this.orgId },
    }).then(crmnumbers => {
      this.crmNumbers = crmNumbersFromResult(crmnumbers)
      this.defaultWabaNumber = getDefaultWabaNumber(this.crmNumbers)
      this.waContextReady = true
      this.waContextPromise = null
    }).catch(() => {
      this.waContextPromise = null
    })
    return this.waContextPromise
  }

  applyCrmOptionsToOpenForm() {
    if (!this.state.modalOpen) return
    const node = getNodeById(this.chatbot, this.editingNodeId)
    if (!node) return
    let patched = false
    if (node.type === NODE_TYPE_MESSAGE) {
      patched = patchMessageContactVariables(this.formDefinition, this.crmContactsFieldDef)
    } else if (node.type === NODE_TYPE_CONTACT) {
      patched = patchContactFormOptions(this.formDefinition, this.stateOptions, this.tagOptions)
    }
    if (patched) this.setState({})
  }

  ensureCrmContacts() {
    if (this.crmContactsPromise) return this.crmContactsPromise
    if (this.crmContactsReady) {
      this.applyCrmOptionsToOpenForm()
      return Promise.resolve()
    }
    this.crmContactsPromise = ApiHelper.callAwait({
      ms: this.ms,
      method: 'GET',
      paths: ['crmcontacts'],
      queryParams: { orgId: this.orgId, pb: 'fieldDef', includeCustomFields: 'true', limit: 1 },
    }).then(result => {
      const fieldDef = result && result.fieldDef
      this.crmContactsFieldDef = fieldDef || null
      this.templateVariables = AppUiHelper.getContactTemplateVariables(this.crmContactsFieldDef)
      this.stateOptions = buildContactStateOptions(fieldDef, this.orgId)
      this.tagOptions = buildContactTagOptions(fieldDef, this.crmContactAttrs)
      this.crmContactsReady = true
      this.crmContactsPromise = null
      this.applyCrmOptionsToOpenForm()
      this.setState({})
    }).catch(() => {
      this.crmContactsPromise = null
    })
    return this.crmContactsPromise
  }

  ensureCrmAttrs() {
    if (this.crmAttrsPromise) return this.crmAttrsPromise
    if (this.crmAttrsReady) {
      this.applyCrmOptionsToOpenForm()
      return Promise.resolve()
    }
    this.crmAttrsPromise = this.ensureCrmContacts().then(() => {
      if (this.crmAttrsReady) return
      return ApiHelper.callAwait({
        ms: this.ms,
        method: 'GET',
        paths: ['items', this.attribsGroupId + '-all'],
        queryParams: { orgId: this.orgId, groupId: this.attribsGroupId },
      }).then(result => {
        this.crmContactAttrs = result
        this.tagOptions = buildContactTagOptions(this.crmContactsFieldDef, result)
        this.crmAttrsReady = true
        this.applyCrmOptionsToOpenForm()
      })
    }).catch(() => {
    }).then(() => {
      this.crmAttrsPromise = null
    })
    return this.crmAttrsPromise
  }

  applyFlowOptionsToOpenForm() {
    if (!this.state.modalOpen) return
    const node = getNodeById(this.chatbot, this.editingNodeId)
    if (!node || node.type !== NODE_TYPE_MESSAGE) return
    if (!patchMessageFlowOptions(this.formDefinition, this.flowOptions)) return
    this.setState({})
  }

  ensureFlowOptions(showLoading) {
    if (this.flowsReady) {
      this.applyFlowOptionsToOpenForm()
      return Promise.resolve()
    }
    if (showLoading) {
      this.flowOptions = LOADING_FLOW_OPTIONS
      this.applyFlowOptionsToOpenForm()
    }
    if (this.flowLoadPromise) return this.flowLoadPromise
    this.flowLoadPromise = this.ensureWaContext().then(() => {
      if (this.flowsReady) return
      if (!this.defaultWabaNumber) {
        this.flowOptions = []
        if (this.waContextReady) this.flowsReady = true
        this.applyFlowOptionsToOpenForm()
        return
      }
      return fetchWhatsappFlowOptionsForNumber(
        this.ms,
        this.orgId,
        this.defaultWabaNumber,
        this.crmNumbers
      ).then(opts => {
        this.flowOptions = opts
        this.flowsReady = true
        this.applyFlowOptionsToOpenForm()
      })
    }).catch(() => {
      this.flowOptions = []
      this.applyFlowOptionsToOpenForm()
    }).then(() => {
      this.flowLoadPromise = null
    })
    return this.flowLoadPromise
  }

  applyLiveChatbotOptionsToOpenForm() {
    if (!this.state.modalOpen) return
    const node = getNodeById(this.chatbot, this.editingNodeId)
    if (!node || node.type !== NODE_TYPE_START_CHATBOT) return
    const chatbotField = ((this.formDefinition && this.formDefinition.steps && this.formDefinition.steps[0] && this.formDefinition.steps[0].fields) || [])
      .find(f => f && f.key === 'chatbotId')
    const currentId = (chatbotField && chatbotField.value) || (node.data && node.data.chatbotId) || ''
    if (!patchStartChatbotSelectOptions(this.formDefinition, this.liveChatbotOptions, currentId, this.chatbotLabelMap)) return
    this.setState({})
  }

  ensureLiveChatbots(showLoading) {
    if (this.liveChatbotsReady) {
      this.applyLiveChatbotOptionsToOpenForm()
      return Promise.resolve()
    }
    if (showLoading) {
      this.liveChatbotOptions = LOADING_LIVE_CHATBOT_OPTIONS
      this.applyLiveChatbotOptionsToOpenForm()
    }
    if (this.liveChatbotLoadPromise) return this.liveChatbotLoadPromise
    this.liveChatbotLoadPromise = fetchLiveChatbots(this.ms, this.orgId).then(items => {
      this.liveChatbotOptions = liveChatbotSelectOptions(items, this.chatbotId)
      this.chatbotLabelMap = chatbotLabelMap(items)
      this.liveChatbotsReady = true
      this.liveChatbotLoadPromise = null
      this.applyLiveChatbotOptionsToOpenForm()
      this.setState({})
    }).catch(() => {
      this.liveChatbotOptions = []
      this.chatbotLabelMap = {}
      this.liveChatbotLoadPromise = null
      this.applyLiveChatbotOptionsToOpenForm()
      this.setState({})
    })
    return this.liveChatbotLoadPromise
  }

  ensureTemplatePreviews() {
    const keys = mappedTemplateKeys(this.chatbot)
    this.templatePreviewLoadId += 1
    const loadId = this.templatePreviewLoadId
    if (!keys.length) {
      this.templatePreviewByKey = {}
      this.templatePreviewPromise = null
      this.setHeaderActions()
      this.setState({})
      return Promise.resolve()
    }
    this.templatePreviewPromise = ApiHelper.callAwait({
      ms: this.ms,
      method: 'POST',
      paths: ['miscs', 'wa-template-preview'],
      queryParams: { orgId: this.orgId },
      jsonBody: { waTemplateKeys: keys },
    }).then(resp => {
      if (loadId !== this.templatePreviewLoadId) return
      this.templatePreviewByKey = indexWaTemplatePreviews(resp)
      this.templatePreviewPromise = null
      this.setHeaderActions()
      this.setState({})
    }).catch(err => {
      if (loadId !== this.templatePreviewLoadId) return
      this.templatePreviewByKey = brokenPreviewForKeys(
        keys,
        Helper.getErrorMsg(err) || 'WhatsApp template details could not be loaded'
      )
      this.templatePreviewPromise = null
      this.setHeaderActions()
      this.setState({})
    })
    return this.templatePreviewPromise
  }

  mergeTemplatePreview(key, preview) {
    const k = String(key || '').trim()
    if (!k) return
    if (!preview) {
      const next = Object.assign({}, this.templatePreviewByKey)
      delete next[k]
      this.templatePreviewByKey = next
      this.setHeaderActions()
      this.setState({})
      return
    }
    this.templatePreviewByKey = Object.assign({}, this.templatePreviewByKey, { [k]: preview })
    this.setHeaderActions()
    this.setState({})
  }

  openSendTemplateEditor(node) {
    const nodeId = node && node.id
    this.editingNodeId = nodeId
    const data = (node && node.data) || {}
    this.ensureCrmContacts()
    this.setState({
      templateWaDialogOpen: true,
      templateWaValue: {
        waTemplateKey: data.waTemplateKey || '',
        waComponents: (data.waComponents && typeof data.waComponents === 'object' && !Array.isArray(data.waComponents))
          ? data.waComponents
          : {},
      },
    })
  }

  closeSendTemplateEditor = () => {
    this.editingNodeId = null
    this.setState({
      templateWaDialogOpen: false,
      templateWaValue: null,
    })
  }

  handleSendTemplateSaved = (updated, livePreview) => {
    const id = this.editingNodeId
    if (!id) return
    const prev = getNodeById(this.chatbot, id)
    const nextData = persistTemplateNodeData({ ...updated, defaultEnabled: !!(prev && prev.data && prev.data.defaultEnabled) })
    const handleSource = (livePreview && livePreview.waTemplate)
      ? { waTemplate: livePreview.waTemplate }
      : undefined
    this.setChatbot(updateNodeData(this.chatbot, id, nextData, handleSource))
    if (nextData.waTemplateKey && livePreview) this.mergeTemplatePreview(nextData.waTemplateKey, livePreview)
  }

  showToast = (message, severity = 'success') => {
    this.setState({
      showToast: true,
      toastMsg: message,
      isErrorToast: severity === 'error',
    })
  }

  closeLeaveConfirm = () => {
    this.pendingLocation = null
    this.pendingAction = null
    this.pendingRefreshCallback = null
    this.setState({ leaveConfirmOpen: false })
  }

  discardLeaveConfirm = () => {
    const loc = this.pendingLocation
    const action = this.pendingAction
    const refreshCb = this.pendingRefreshCallback
    this.pendingLocation = null
    this.pendingAction = null
    this.pendingRefreshCallback = null
    this.dirty = false
    this.setState({ leaveConfirmOpen: false })
    if (action === 'REFRESH') {
      super.fetchItems(refreshCb)
      return
    }
    this.allowLeave = true
    if (this.unblock) this.unblock()
    if (action === 'POP') {
      this.props.history.goBack()
      return
    }
    if (loc) this.props.history.push(loc)
  }

  onNodeClick = (nodeId) => {
    const node = getNodeById(this.chatbot, nodeId)
    if (!node) return
    this.editingNodeId = nodeId
    if (node.type === NODE_TYPE_CONTACT) {
      this.ensureCrmContacts()
      this.ensureCrmAttrs()
      this.openModalForEdit(
        contactNodeDataToFormItem(node.data),
        getChatbotContactFieldDef(this.stateOptions, this.tagOptions)
      )
      return
    }
    if (node.type === NODE_TYPE_START_CHATBOT) {
      this.ensureLiveChatbots(true)
      this.openModalForEdit(
        startChatbotNodeDataToFormItem(node.data),
        getChatbotStartChatbotFieldDef(this.liveChatbotOptions, node.data, this.chatbotLabelMap)
      )
      return
    }
    if (node.type === NODE_TYPE_AGENT) {
      this.openModalForEdit(
        agentNodeDataToFormItem(node.data),
        getChatbotAgentFieldDef(this.agentSettings().providerOptions, node.data)
      )
      return
    }
    if (node.type === NODE_TYPE_TEMPLATE) {
      this.openSendTemplateEditor(node)
      return
    }
    this.ensureFlowOptions(true)
    this.ensureCrmContacts()
    this.openModalForEdit(nodeDataToFormItem(node.data), getChatbotMessageFieldDef(this.flowOptions, this.crmContactsFieldDef))
  }

  customSubmit(options) {
    const { formData, caller } = options
    if (!this.editingNodeId) {
      if (caller) caller.setState({ inProcess: false })
      return
    }
    const prev = getNodeById(this.chatbot, this.editingNodeId)
    if (prev && prev.type === NODE_TYPE_CONTACT) {
      this.setChatbot(updateNodeData(this.chatbot, this.editingNodeId, formDataToContactNodeData(formData)))
    } else if (prev && prev.type === NODE_TYPE_START_CHATBOT) {
      this.setChatbot(updateNodeData(this.chatbot, this.editingNodeId, formDataToStartChatbotNodeData(formData)))
    } else if (prev && prev.type === NODE_TYPE_AGENT) {
      this.setChatbot(updateNodeData(this.chatbot, this.editingNodeId, formDataToAgentNodeData(formData)))
    } else {
      this.setChatbot(updateNodeData(this.chatbot, this.editingNodeId, formDataToNodeData({
        ...(formData || {}),
        ...uploadLinksFromForm(formData, caller),
      }, prev && prev.data)))
    }
    this.editingNodeId = null
    if (caller) caller.setState({ inProcess: false, success: true, message: '' })
    this.setState({ modalOpen: false })
  }

  renderAboveTable() {
    const agentSettings = this.agentSettings()
    const isEmpty = !((this.chatbot && this.chatbot.nodes) || []).length
    const blockReason = this.templateBlockReason()
    const saveDisabled = !this.dirty || this.saving || !!blockReason
    let saveTooltip = 'Save'
    if (this.saving) saveTooltip = 'Saving…'
    else if (blockReason && this.dirty) saveTooltip = blockReason
    else if (!this.dirty) saveTooltip = 'No changes to save'
    return (
      <div className={css(Styles.containerNarrow)}>
        <div className={css(Styles.builderCard)}>
          {!isEmpty && (
            <ChatbotNodePalette
              palette={agentSettings.palette}
              onAddType={this.addChatbotNode}
              onSave={() => this.saveChatbot()}
              saveDisabled={saveDisabled}
              saveTooltip={saveTooltip}
            />
          )}
          <div className={css(Styles.canvasWrap)}>
            <ChatbotFlowCanvas
              ref={this.flowCanvasRef}
              chatbot={this.chatbot}
              orgId={this.orgId}
              templatePreviewByKey={this.templatePreviewByKey}
              chatbotOptions={this.liveChatbotOptions}
              chatbotLabels={this.chatbotLabelMap}
              agentProviderOptions={agentSettings.providerOptions}
              palette={agentSettings.palette}
              onNodeDragStop={this.onNodeDragStop}
              onConnect={this.onConnectNodes}
              onAddConnectedNode={this.addConnectedChatbotNode}
              onEdgeDelete={this.onEdgeDelete}
              onNodeDelete={this.onNodeDelete}
              onNodeDuplicate={this.onNodeDuplicate}
              onSetStartNode={this.onSetStartNode}
              onNodeToggleDefault={this.onNodeToggleDefault}
              onNodeClick={this.onNodeClick}
              onAutoLayout={this.onAutoLayout}
            />
            {isEmpty ? <ChatbotEmptyStart palette={agentSettings.palette} onAddType={this.addChatbotNode} /> : null}
          </div>
        </div>
        <ChatbotConfirmDialog
          isOpen={!!this.state.leaveConfirmOpen}
          onGoBack={this.closeLeaveConfirm}
          onDiscard={this.discardLeaveConfirm}
        />
        {this.state.templateWaDialogOpen && (
          <WaTemplateKeyDialog
            open={!!this.state.templateWaDialogOpen}
            onClose={this.closeSendTemplateEditor}
            orgId={this.orgId}
            value={this.state.templateWaValue}
            previewByKey={this.templatePreviewByKey}
            templateVariables={this.templateVariables}
            onSave={this.handleSendTemplateSaved}
            showToast={this.showToast}
          />
        )}
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  containerNarrow: {
    width: '100%',
    paddingBottom: 16,
    boxSizing: 'border-box',
  },
  builderCard: {
    width: '100%',
    height: 'calc(100vh - ' + (AppTheme.headerbarHeight + 16) + 'px)',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    backgroundColor: AppTheme.secondaryBg,
    border: '1px solid ' + AppTheme.borderColor,
    borderRadius: AppTheme.borderRadius,
    overflow: 'hidden',
    boxSizing: 'border-box',
  },
  canvasWrap: {
    flex: 1,
    minHeight: 0,
    width: '100%',
    position: 'relative',
    backgroundColor: AppTheme.secondaryBg,
  },
})
